import { render, staticRenderFns } from "./BooksPreview.vue?vue&type=template&id=b4ea5e22&scoped=true"
import script from "./BooksPreview.vue?vue&type=script&lang=js"
export * from "./BooksPreview.vue?vue&type=script&lang=js"
import style0 from "./BooksPreview.vue?vue&type=style&index=0&id=b4ea5e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ea5e22",
  null
  
)

export default component.exports